import { Component, OnInit, OnDestroy } from '@angular/core';

import { EntityValidationErrorResponse } from '../../shared/models';

import { ModalService } from '../../shared/modules/modal/modal.service';
import { NotificationService } from '../../shared/services';

import {
  ClosableModalWithErrorResponseModel
} from '../../shared/components/base/closable-modal-with-error-response-model';

@Component({
  selector: 'planning-entity-modal',
  templateUrl: './planning-entity-modal.component.html',
  styleUrls: ['./planning-entity-modal.component.css']
})
export class PlanningEntityModalComponent
  extends ClosableModalWithErrorResponseModel<EntityValidationErrorResponse>
  implements OnInit, OnDestroy {

  constructor(
    protected notificationService: NotificationService,
    protected modalService: ModalService,
  ) {
    super(notificationService, modalService);
  }

  data;
  entityName: string;
  nameEntryState = true;
  placeholder: string;

  ngOnInit() {
    this.placeholder = this.data.isPrimaryEntity ? 'Enter primary entity name' : 'Enter trading partner name';
  }

  exitModal(): void {
    this.closeAllModals();
  }

  handleSubmit() {
    if (this.data.isPrimaryEntity) {
      this.submitWithoutFinancials();
    } else {
      this.switchModalState();
    }
  }

  submitWithoutFinancials() {
    this.success(this.entityName, false);
  }

  submitToFinancials() {
    this.success(this.entityName, true);
  }

  switchModalState() {
    this.nameEntryState = !this.nameEntryState;
  }

}
